/* ica-collection.js
   Collection page client behavior.
   - Mobile filter drawer toggle (open/close, ESC close, focus trap entry)
   - Filter dimension accordion (each fieldset collapsible)
   - Sort dropdown change handler — submits the page with sort_by= URL param

   Vanilla JS, defer-loaded. No jQuery, no render-blocking.
*/
(function () {
  'use strict';

  // ---- 1. Filter drawer toggle (mobile only) ----
  function initDrawer() {
    var openBtn = document.getElementById('ica-open-filter-drawer');
    var closeBtn = document.getElementById('ica-close-filter-drawer');
    var applyBtn = document.getElementById('ica-drawer-apply');
    var rail = document.getElementById('ica-filter-rail');
    if (!openBtn || !rail) return;

    function open() {
      rail.classList.add('is-open');
      document.body.classList.add('ica-drawer-open');
      openBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 0);
    }
    function close() {
      rail.classList.remove('is-open');
      document.body.classList.remove('ica-drawer-open');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (applyBtn) applyBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && rail.classList.contains('is-open')) close();
    });
  }

  // ---- 2. Filter dimension accordion ----
  function initAccordion() {
    var heads = document.querySelectorAll('.ica-filter-dim-head');
    heads.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dim = btn.closest('.ica-filter-dim');
        if (!dim) return;
        var expanded = dim.getAttribute('aria-expanded') === 'true';
        dim.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  // ---- 3. Sort dropdown — preserve other URL params + reload ----
  function initSort() {
    var selects = document.querySelectorAll('[data-ica-sort]');
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page'); // reset to page 1 on sort change
        window.location.href = url.toString();
      });
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    initDrawer();
    initAccordion();
    initSort();
  });
})();
